import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';
import { useEffect, useRef, useState } from 'react';
import {
    anulaFuenteSiniestro,
    creaSiniestro,
    modificaSiniestro,
    obtieneFuentesSiniestro,
    recuperaConfigByCab
} from '../../services/Siniestro/SiniestroService';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import SelectorUbicacion from '../DatosEmpleado/SelectorUbicacion';
import { fechaHoraToJava } from '../../util/dateUtils';
import AdicionFuente from './AdicionFuente';
import { ConfirmDialog } from 'primereact/confirmdialog';
import AsociarProyecto from './AsociarProyecto';
import AdiTipoSiniestro from './AdiTipoSiniestro';
import AdiSector from './AdiSector';
import { Checkbox } from 'primereact/checkbox';

const FormSiniestroII = ({ funcVolver, datosSiniestro, esAdmin = false }) => {
    const [procesando, setProcesando] = useState(false);
    const [cargaTipoSin, setCargaTipoSin] = useState(false);
    const [lstTipoSin, setLstTipoSin] = useState([]);
    const [tipoSin, setTipoSin] = useState({});
    const [tipoSinEdit, setTipoSinEdit] = useState({});

    // Estados para el Sector
    const [cargaSectorSin, setCargaSectorSin] = useState(false);
    const [lstSectorSin, setLstSectorSin] = useState([]);
    const [sectorSin, setSectorSin] = useState({});
    const [sectorSinEdit, setSectorSinEdit] = useState({});
    const [visibleAdiSector, setVisibleAdiSector] = useState(false);
    const [recargaSector, setRecargaSector] = useState(false);

    const [fecha, setFecha] = useState(new Date());
    const [hora, setHora] = useState(() => {
        const d = new Date();
        d.setHours(0, 0, 0, 0);
        return d;
    });
    const [puntoGPS, setPuntoGPS] = useState('');
    const [mostrarMapa, setMostrarMapa] = useState(false);
    const [descripcion, setDescripcion] = useState('');
    const [lstFuentes, setLstFuentes] = useState([]);
    const [cargaFuente, setCargaFuente] = useState(false);
    const [disableFuente, setDisableFuente] = useState(true);
    const [fuente, setFuente] = useState({});
    const [visibleFuente, setVisibleFuente] = useState(false);
    const [siniestroId, setSiniestroId] = useState();
    const [sinCreado, setSinCreado] = useState({});
    const [cambioFuente, setCambioFuente] = useState(false);
    const [visibleAnula, setVisibleAnula] = useState(false);
    const [ejecutaConfig, setEjecutaConfig] = useState(false);
    const [visibleAsocia, setVisibleAsocia] = useState(false);
    const [visibleAdiTipo, setVisibleAdiTipo] = useState(false);
    const [recargaTipo, setRecargaTipo] = useState(false);
    const [esPrivado, setEsPrivado] = useState(false);
    const [errores, setErrores] = useState({});

    const toastForm = useRef();

    useEffect(() => {
        const recuperaTipoSin = async () => {
            const CODE_CONFIGCAB_TIPOSIN = 'SIN-0000-0000';
            try {
                setCargaTipoSin(true);
                const datos = await recuperaConfigByCab(CODE_CONFIGCAB_TIPOSIN);
                setLstTipoSin(datos);
                if (datosSiniestro?.tipoSiniestroId) {
                    const tipoBus = datos.find((item) => item.configuracionDetId === datosSiniestro?.tipoSiniestroId);
                    if (tipoBus) {
                        setTipoSin(tipoBus);
                    }
                    //actualizar los campos
                    setPuntoGPS(datosSiniestro?.puntoGPS || '');
                    setDescripcion(datosSiniestro?.descripcion);
                    setSiniestroId(datosSiniestro?.siniestroId);
                    setEsPrivado(datosSiniestro?.esPrivado);
                    setDisableFuente(false);
                    // sacaar la fecha y hora.
                    const [fechaTexto, horaTexto] = datosSiniestro?.fechaSiniestro.split(' ');
                    const [dia, mes, año] = fechaTexto.split('/').map(Number);
                    const objetoFecha = new Date(año, mes - 1, dia);
                    setFecha(objetoFecha);
                    //hora
                    const [horas, minutos, segundos] = horaTexto.split(':').map(Number);
                    const objetoHora = new Date(año, mes - 1, dia, horas, minutos, segundos);
                    setHora(objetoHora);
                }
            } catch (error) {
                console.error('ERROR: Error al recuperar Tipos de siniestro');
            } finally {
                setCargaTipoSin(false);
            }
        };
        recuperaTipoSin();
    }, [
        datosSiniestro?.descripcion,
        datosSiniestro?.esPrivado,
        datosSiniestro?.fechaSiniestro,
        datosSiniestro?.puntoGPS,
        datosSiniestro?.siniestroId,
        datosSiniestro?.tipoSiniestroId,
        recargaTipo
    ]);

    useEffect(() => {
        const recuperaSectorSin = async () => {
            const CODE_CONFIGCAB_SECTOR = 'SIN-0000-SECT';
            try {
                setCargaSectorSin(true);
                const datos = await recuperaConfigByCab(CODE_CONFIGCAB_SECTOR);
                setLstSectorSin(datos);
                if (datosSiniestro?.sectorConfigId) {
                    const sectorBus = datos.find((item) => item.configuracionDetId === datosSiniestro?.sectorConfigId);
                    if (sectorBus) {
                        setSectorSin(sectorBus);
                    }
                }
            } catch (error) {
                console.error('ERROR: Error al recuperar Sector de siniestro');
            } finally {
                setCargaSectorSin(false);
            }
        };
        recuperaSectorSin();
    }, [datosSiniestro?.sectorConfigId, recargaSector]);

    useEffect(() => {
        const recuperaFuentes = async () => {
            //console.log('INGRESANDO....:', datosSiniestro?.siniestroId);
            if (datosSiniestro?.siniestroId || sinCreado.siniestroId) {
                try {
                    setCargaFuente(true);
                    const datos = await obtieneFuentesSiniestro(
                        datosSiniestro?.siniestroId ? datosSiniestro?.siniestroId : sinCreado.siniestroId
                    );
                    //console.log('FUENTES: ', datos);
                    setLstFuentes(datos);
                } catch (error) {
                    console.error('Error al obtener Fuentes');
                } finally {
                    setCargaFuente(false);
                }
            }
        };
        recuperaFuentes();
    }, [cambioFuente, datosSiniestro?.siniestroId, sinCreado.siniestroId]);

    const handleGuardar = async () => {
        let hasError = false;
        const nuevosErrores = {};

        if (!tipoSin?.configuracionDetId) {
            nuevosErrores.tipoSin = true;
            toastForm.current.show({ severity: 'warn', summary: 'Atención', detail: 'Debe seleccionar Tipo Evento'});
            hasError = true;
        }
        if (!fecha) {
            nuevosErrores.fecha = true;
            toastForm.current.show({ severity: 'warn', summary: 'Atención', detail: 'Debe poner la fecha' });
            hasError = true;
        }
        if (!puntoGPS) {
            nuevosErrores.puntoGPS = true;
            toastForm.current.show({ severity: 'warn', summary: 'Atención', detail: 'Ingrese el punto GPS' });
            hasError = true;
        }
        if (!descripcion) {
            nuevosErrores.descripcion = true;
            toastForm.current.show({ severity: 'warn', summary: 'Atención', detail: 'Ingrese una descripción.' });
            hasError = true;
        }

        setErrores(nuevosErrores);
        if (hasError) return;

        const objPost = {
            tipoSiniestroConfigId: tipoSin?.configuracionDetId,
            sectorConfigId: sectorSin?.configuracionDetId,
            fecha: fechaHoraToJava(fecha, hora),
            descripcion: descripcion,
            puntoGPS: puntoGPS,
            esPrivado: esPrivado
        };

        if (siniestroId) {
            objPost['siniestroId'] = siniestroId;
            //console.log('PARA MODIFICAR...: ', objPost);
            try {
                setProcesando(true);
                const data = await modificaSiniestro(objPost);
                //console.log('MODIFICADDO...:', data);
                if (data.siniestroId) {
                    toastForm.current.show({
                        severity: 'success',
                        summary: 'Exito',
                        detail: 'Se ha registrado un Datos del Evento.'
                    });
                }
            } catch (err) {
                console.error('Error al Modificar el evento de Siniestro');
                toastForm.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Error al Modificar el Evento'
                });
            } finally {
                setProcesando(false);
            }
        } else {
            // Guardar Datos nuevos
            try {
                setProcesando(true);
                const data = await creaSiniestro(objPost);
                //console.log(data);
                setSiniestroId(data.siniestroId);
                setDisableFuente(false);
                toastForm.current.show({
                    severity: 'success',
                    summary: 'Exito',
                    detail: 'Se ha registrado un Nuevo Evento.'
                });
                const sin = {
                    siniestroId: data.siniestroId,
                    descripcion: data.descripcion
                };
                setSinCreado(sin);
            } catch (error) {
                console.error('Error al Crear el evento de Siniestro');
                toastForm.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Error al Registrar el Evento'
                });
            } finally {
                setProcesando(false);
            }
        }
    };

    const bodyLink = (rowData) => {
        return (
            <a href={rowData.link} target="_blank" rel="noopener noreferrer" className="text-blue-500 underline">
                {rowData.link}
            </a>
        );
    };

    const actionFBody = (rowData) => {
        return (
            <div className="flex gap-2 justify-content-center">
                <Button
                    icon="pi pi-pencil"
                    className="p-button-rounded p-button-info"
                    tooltip="Editar Fuente"
                    onClick={() => editaFuente(rowData)}
                />
                <Button
                    icon="pi pi-trash"
                    className="p-button-rounded p-button-danger"
                    tooltip="Eliminar Fuente"
                    onClick={() => borraFuente(rowData)}
                />
            </div>
        );
    };

    const confirmaMapa = (puntoMapa) => {
        setPuntoGPS(puntoMapa);
        setMostrarMapa(false);
    };

    const cancelaMapa = () => {
        setMostrarMapa(false);
    };

    const funcCerrarFuente = () => {
        // para ver cambios
        setCambioFuente((prev) => !prev);
        setVisibleFuente(false);
    };

    // Para la Edicion de la fuente
    const editaFuente = (datosF) => {
        setFuente(datosF);
        setVisibleFuente(true);
    };

    const borraFuente = (datosF) => {
        setFuente(datosF);
        setVisibleAnula(true);
    };

    const anulaFuente = async () => {
        try {
            setEjecutaConfig(true);
            const datos = await anulaFuenteSiniestro(fuente.siniestroFuenteId);
            if (datos.siniestroFuenteId) {
                toastForm.current.show({
                    severity: 'success',
                    summary: 'Éxito',
                    detail: 'Se ha anulado el Evento'
                });
            }
            setVisibleAnula(false);
            setCambioFuente((prev) => !prev);
        } catch (err) {
            toastForm.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'No se ha podido eliminar el Evento'
            });
        } finally {
            setEjecutaConfig(false);
        }
    };

    const footerAnula = () => {
        return (
            <div>
                <Button
                    label="No"
                    icon="pi pi-times"
                    onClick={() => setVisibleAnula(false)}
                    className="p-button-text"
                    disabled={ejecutaConfig}
                />
                <Button label="Sí" icon="pi pi-check" onClick={anulaFuente} loading={ejecutaConfig} autoFocus />
            </div>
        );
    };

    const ocultaAsoc = () => {
        setVisibleAsocia(false);
    };

    const adiTipoSiniestro = () => {
        setTipoSinEdit({});
        setVisibleAdiTipo(true);
    };

    const editTipoSiniestro = () => {
        setTipoSinEdit(tipoSin);
        setVisibleAdiTipo(true);
    };

    const salirAdiTipo = () => {
        setVisibleAdiTipo(false);
        setRecargaTipo((prev) => !prev);
    };

    const adiSectorSiniestro = () => {
        setSectorSinEdit({});
        setVisibleAdiSector(true);
    };

    const editSectorSiniestro = () => {
        setSectorSinEdit(sectorSin);
        setVisibleAdiSector(true);
    };

    const salirAdiSector = () => {
        setVisibleAdiSector(false);
        setRecargaSector((prev) => !prev);
    };

    return (
        <div className="surface-card p-5 shadow-3 border-round-xl text-800">
            <Toast ref={toastForm} />
            <Dialog visible={mostrarMapa} onHide={() => setMostrarMapa(false)}>
                <SelectorUbicacion coordenadaInicial={puntoGPS} onConfirmar={confirmaMapa} onCancelar={cancelaMapa} />
            </Dialog>
            <Dialog
                header="Adicion Fuente"
                visible={visibleFuente}
                style={{ width: '50vw' }}
                onHide={() => setVisibleFuente(false)}
            >
                <AdicionFuente
                    siniestroDat={datosSiniestro ? datosSiniestro : sinCreado}
                    toast={toastForm}
                    funcCerrar={funcCerrarFuente}
                    fuenteDat={fuente}
                />
            </Dialog>
            <ConfirmDialog
                visible={visibleAnula}
                onHide={() => setVisibleAnula(false)}
                message="Confirma Anular el Evento..?"
                header="Anula Evento"
                icon="pi pi-exclamation-triangle"
                footer={footerAnula}
            />
            <Dialog
                header="Relacionar Evento con Proyecto"
                visible={visibleAsocia}
                onHide={() => setVisibleAsocia(false)}
                style={{ width: '80vw' }}
            >
                <AsociarProyecto datSiniestro={datosSiniestro || sinCreado} funcSalir={ocultaAsoc} />
            </Dialog>
            <Dialog
                visible={visibleAdiTipo}
                onHide={() => setVisibleAdiTipo(false)}
                header={tipoSinEdit?.configuracionDetId ? 'Editar Tipo Evento' : 'Nuevo Tipo Evento'}
            >
                <AdiTipoSiniestro funcSalir={salirAdiTipo} datTipo={tipoSinEdit} />
            </Dialog>
            <Dialog
                visible={visibleAdiSector}
                onHide={() => setVisibleAdiSector(false)}
                header={sectorSinEdit?.configuracionDetId ? 'Editar Sector' : 'Nuevo Sector'}
            >
                <AdiSector funcSalir={salirAdiSector} datSector={sectorSinEdit} />
            </Dialog>
            <div className="flex justify-content-between align-items-center p-3 border-bottom-1 surface-border mb-4">
                <span className="text-2xl font-semibold text-primary">
                    <i className={datosSiniestro?.siniestroId ? "pi pi-file-edit mr-2 text-2xl" : "pi pi-plus-circle mr-2 text-2xl"}></i>
                    {datosSiniestro?.siniestroId ? 'Edición de Evento' : 'Registro de Nuevo Evento'}
                </span>
                <div className="flex gap-2">
                    {/*<Button
                        label="Asociar a Proyectos"
                        icon="pi pi-link"
                        onClick={() => setVisibleAsocia(true)}
                        disabled={disableFuente}
                    />*/}
                    <Button
                        icon="pi pi-save"
                        label="Guardar Datos"
                        className="p-button-primary"
                        onClick={handleGuardar}
                        loading={procesando}
                    />
                </div>
            </div>
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 mb-3">
                    <Button
                        label="Volver a la lista"
                        icon="pi pi-arrow-left"
                        className="p-button-text p-button-secondary w-auto p-0 mb-2"
                        onClick={funcVolver}
                    />
                </div>
                <div className="col-12 mb-2">
                    <h5 className="m-0 text-700 font-medium"><i className="pi pi-info-circle mr-2"></i>Datos Generales</h5>
                    <hr className="surface-border opacity-50 mb-3" />
                </div>
                <div className="field col-12 md:col-6">
                    <label htmlFor="cboTipoSiniestro" className="font-semibold">Tipo de Evento:</label>
                    <div className="formgrid grid p-fluid mb-3">
                        <div className="field col-12 md:col-10">
                            {cargaTipoSin ? (
                                <div className="flex align-items-center">
                                    <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                                </div>
                            ) : (
                                <Dropdown
                                    options={lstTipoSin}
                                    value={tipoSin}
                                    onChange={(evt) => setTipoSin(evt.value)}
                                    optionLabel="nombre"
                                    inputId="cboTipoSiniestro"
                                    placeholder="Selecciona un Cliente"
                                    showClear
                                    filter
                                    className={errores.tipoSin ? 'p-invalid' : ''}
                                />
                            )}
                            {errores.tipoSin && <small className="p-error block mt-1">Requerido</small>}
                        </div>
                        {esAdmin && (
                            <div className="field col-12 md:col-1 ">
                                <Button icon="pi pi-plus" onClick={adiTipoSiniestro} tooltip="Adicionar Tipo Evento" />
                            </div>
                        )}
                        {esAdmin && (
                            <div className="field col-12 md:col-1 ">
                                <Button
                                    icon="pi pi-pencil"
                                    onClick={editTipoSiniestro}
                                    tooltip="Editar Tipo Evento"
                                    disabled={!tipoSin?.configuracionDetId}
                                />
                            </div>
                        )}
                    </div>
                </div>
                
                <div className="field col-12 md:col-6">
                    <label htmlFor="cboSector" className="font-semibold">Sector de Evento:</label>
                    <div className="formgrid grid p-fluid mb-3">
                        <div className="field col-12 md:col-10">
                            {cargaSectorSin ? (
                                <div className="flex align-items-center">
                                    <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                                </div>
                            ) : (
                                <Dropdown
                                    options={lstSectorSin}
                                    value={sectorSin}
                                    onChange={(evt) => setSectorSin(evt.value)}
                                    optionLabel="nombre"
                                    inputId="cboSector"
                                    placeholder="Selecciona un Sector"
                                    showClear
                                    filter
                                />
                            )}
                        </div>
                        {esAdmin && (
                            <div className="field col-12 md:col-1 ">
                                <Button icon="pi pi-plus" onClick={adiSectorSiniestro} tooltip="Adicionar Sector" />
                            </div>
                        )}
                        {esAdmin && (
                            <div className="field col-12 md:col-1 ">
                                <Button
                                    icon="pi pi-pencil"
                                    onClick={editSectorSiniestro}
                                    tooltip="Editar Sector"
                                    disabled={!sectorSin?.configuracionDetId}
                                />
                            </div>
                        )}
                    </div>
                </div>
                
                <div className="col-12 mt-3 mb-2">
                    <h5 className="m-0 text-700 font-medium"><i className="pi pi-map-marker mr-2"></i>Ubicación y Detalles</h5>
                    <hr className="surface-border opacity-50 mb-3" />
                </div>
                
                <div className="field col-12 md:col-6">
                    <div className="formgrid grid p-fluid mb-3">
                        <div className="field col-12 md:col-6">
                            <label htmlFor="cboUbicacion" className="font-semibold">Fecha:</label>
                            <Calendar
                                value={fecha}
                                onChange={(evt) => setFecha(evt.value)}
                                dateFormat="dd/mm/yy"
                                showIcon
                                className={errores.fecha ? 'p-invalid' : ''}
                            />
                            {errores.fecha && <small className="p-error block mt-1">Requerido</small>}
                        </div>
                        <div className="field col-12 md:col-6">
                            <label className="font-semibold">Hora:</label>
                            <Calendar value={hora} onChange={(evt) => setHora(evt.value)} hourFormat="24" timeOnly />
                        </div>
                    </div>
                </div>
                <div className="field col-12 md:col-5">
                    <label htmlFor="cboUbicacion" className="font-semibold">Punto GPS:</label>
                    <InputText value={puntoGPS} readOnly className={errores.puntoGPS ? 'p-invalid' : ''} placeholder="Use el botón para buscar..." />
                    {errores.puntoGPS && <small className="p-error block mt-1">Requerido</small>}
                </div>
                <div className="field col-12 md:col-1 flex align-items-end">
                    <Button icon="pi pi-map-marker" onClick={() => setMostrarMapa(true)} />
                </div>
                <div className="field col-12 md:col-2 flex align-items-end">
                    <Checkbox
                        inputId="chkEsPrivado"
                        onChange={(evt) => setEsPrivado(evt.checked)}
                        checked={esPrivado}
                    />
                    <label htmlFor="chkEsPrivado">Es Privado</label>
                </div>
                <div className="field col-12 md:col-4">
                    <label style={{ visibility: 'hidden' }}>Texto oculto</label>
                </div>
                <div className="field col-12 md:col-12 mt-2">
                    <label htmlFor="cboUbicacion" className="font-semibold">Descripción del Evento:</label>
                    <InputTextarea
                        value={descripcion}
                        className={errores.descripcion ? 'p-invalid' : ''}
                        onChange={(evt) => {
                            const aMayus = evt.target.value.toUpperCase();
                            setDescripcion(aMayus);
                        }}
                    />
                    {errores.descripcion && <small className="p-error block mt-1">La descripción es obligatoria</small>}
                </div>

                <div className="col-12 mt-4 mb-2">
                    <h5 className="m-0 text-700 font-medium"><i className="pi pi-images mr-2"></i>Fuentes y Evidencias</h5>
                    <hr className="surface-border opacity-50 mb-3" />
                </div>
                <div className="field col-12 md:col-10">
                    <DataTable
                        header={<div className="font-medium text-lg pb-1 text-600">Archivos Adjuntos</div>}
                        value={lstFuentes}
                        showGridlines
                        size="small"
                        paginator
                        rows={5}
                        rowsPerPageOptions={[5, 10, 25]}
                        responsiveLayout="scroll"
                        loading={cargaFuente}
                    >
                        <Column header="Fuente" field="fuente"></Column>
                        <Column header="Descripcion" field="descripcion"></Column>
                        <Column header="Link" body={bodyLink}></Column>
                        <Column header="Acciones" body={actionFBody}></Column>
                    </DataTable>
                </div>
                <div className="field col-12 md:col-2">
                    <Button
                        icon="pi pi-plus"
                        label="Adicion Fuente"
                        disabled={disableFuente}
                        onClick={() => {
                            setFuente({});
                            setVisibleFuente(true);
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default FormSiniestroII;
